import request from '@/utils/request'

export function getEmpPermission (data) {
  return request({
    url: 'api/emp/getEmpPermission',
    method: 'post',
    params: data
  })
}

export function listSystemPermission (data) {
  return request({
    url: 'api/emp/listSystemPermission',
    method: 'post',
    params: data
  })
}

export function listGroupPermission (data) {
  return request({
    url: 'api/emp/listGroupPermission',
    method: 'get',
    params: data
  })
}

export function empList (data) {
  return request({
    url: 'api/emp/list',
    method: 'post',
    params: data
  })
}

export function empAdd (data) {
  return request({
    url: 'api/emp/add',
    method: 'post',
    data: data
  })
}

export function empUpdate (data) {
  return request({
    url: 'api/emp/update',
    method: 'post',
    data: data
  })
}

export function cardList (data) {
  return request({
    url: 'api/group/card',
    method: 'post',
    params: data
  })
}

export function listPayType (data) {
  return request({
    url: 'api/group/listPayType',
    method: 'post',
    params: data
  })
}

export function addPayType (data) {
  return request({
    url: 'api/group/addPayType',
    method: 'post',
    params: data
  })
}

export function updatePayType (data) {
  return request({
    url: 'api/group/updatePayType',
    method: 'post',
    params: data
  })
}

export function updateReserve (data) {
  return request({
    url: 'api/group/updateConfig',
    method: 'post',
    params: data
  })
}

export function getReserve (data) {
  return request({
    url: 'api/group/getReserve',
    method: 'post',
    params: data
  })
}

export function checkEmpPwd (data) {
  return request({
    url: 'api/account/checkEmpPwd',
    method: 'post',
    data: data
  })
}

export function getSmsSetting (data) {
  return request({
    url: 'api/group/getSmsSetting',
    method: 'post',
    data: data
  })
}

export function setSmsSetting (data) {
  return request({
    url: 'api/group/setSmsSetting',
    method: 'post',
    data: data
  })
}

export function getSmsStock (data) {
  return request({
    url: 'api/group/getSmsStock',
    method: 'post',
    data: data
  })
}

export function setCalcTypeSetting (data) {
  return request({
    url: 'api/group/updateCalcType',
    method: 'post',
    data: data
  })
}
